import { useQuery } from "react-query";
import { getCodeLevels } from "../../../../actions/Utilities/Common";

export const useGetCodeLevel = () => {
  return useQuery("GetCodeLevel", getCodeLevels, {
    refetchOnWindowFocus: false,
    staleTime: Infinity,
  });
};
